import { Skeleton } from '@/components/ui/skeleton';

export function PhotoGridSkeleton({ count = 12, viewMode = 'grid' }) {
  return (
    <div className={
      viewMode === 'masonry'
        ? "columns-2 sm:columns-3 md:columns-4 lg:columns-6 gap-[6px]"
        : "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-[6px]"
    }>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="relative rounded-2xl overflow-hidden bg-slate-100 dark:bg-slate-800 ring-1 ring-slate-200/50 dark:ring-slate-700/50"
          style={{
            aspectRatio: viewMode === 'masonry' ? `4/${3 + (i % 3)}` : '4/3',
            animationDelay: `${i * 0.05}s`,
            marginBottom: viewMode === 'masonry' ? '6px' : 0
          }}
        >
          {/* Base skeleton with wave animation */}
          <div
            className="absolute inset-0 bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200 dark:from-slate-800 dark:via-slate-700 dark:to-slate-800 animate-skeleton-wave"
            style={{
              backgroundSize: '200% 100%',
              animationDelay: `${i * 0.1}s`
            }}
          />

          {/* Shimmer overlay */}
          <div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 dark:via-white/10 to-transparent animate-shimmer"
            style={{
              backgroundSize: '200% 100%',
              animationDelay: `${i * 0.15}s`
            }}
          />

          {/* Glass shine effect at top */}
          <div className="absolute top-0 left-0 right-0 h-1/2 bg-gradient-to-b from-white/20 dark:from-white/5 to-transparent rounded-t-2xl" />

          {/* Subtle inner shadow for depth */}
          <div className="absolute inset-0 shadow-[inset_0_0_20px_rgba(0,0,0,0.05)] dark:shadow-[inset_0_0_20px_rgba(0,0,0,0.2)] rounded-2xl" />
        </div>
      ))}
    </div>
  );
}

export default PhotoGridSkeleton;
